export const config = {
  scrollZoom: false,
  autosizable: true,
  responsive: true,
  showTips: false,
  displaylogo: false,
  displayModeBar: false,
  doubleClick: false,
  doubleClickDelay: 500,
  modeBarButtonsToRemove: ['toImage']
}
